module.exports = __webpack_public_path__ + "media/video_05.f9454836.mp4";